import { useQuery } from "@tanstack/react-query";
import { Scene, SimpleScene } from "@/model";
import sceneRepository from "@/repository/sceneRepository";


export const useScenes = (scenarioId: string, condition?: string) => {
    return useQuery<Scene[]>({
        queryKey: ['scenes', scenarioId, condition] ,
        queryFn: async () => {
            const data = await sceneRepository.find(scenarioId, condition);
            return data.data ?? [];
        },
        enabled: !!scenarioId
    });
};

export const useSimpleScenes = (scenarioId: string, condition?: string) => {
    return useQuery<SimpleScene[]>({
        queryKey: ['scenes', scenarioId, condition],
        queryFn: async () => {
            const data = await sceneRepository.find(scenarioId, condition);
            return data.data?.map((scene: Scene) => ({
                scene_id: scene.id,
                custom_id: scene.custom_id,
                name: scene.name
            })) ?? [];
        },
        enabled: !!scenarioId
    });
};
